import type { FaireProductEntity } from "../../entity_types/product";

export const p_6decuppm2u: FaireProductEntity = {
  token: "p_6decuppm2u",
  type: "product",
  name: "Trendy Rivet Bead Straw Evening Clutch Handbag DP25H593",
  brandToken: "b_kw6x2ac3kg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/db0ca984bde76aceb344e67452d151bff7fbb1a2aa9cb667eb54c8d04430b3ed.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0eb6109ae55cd84fad4c0f5f77e95bd5df7794809ac9dcc00f778b6cf4cd3b60.jpeg",
    "https://cdn.faire.com/fastly/e900845bb5e0eef88ab53014c5fc975fd7007bfb4b37f3d4fb4832baf3963e59.jpeg",
    "https://cdn.faire.com/fastly/890805d059abb88fc209f130770f9856f03a2906095ba01e5e6a44bf180c0b93.jpeg",
    "https://cdn.faire.com/fastly/28ed731a7ef86e144ebe61ec1d99115bf75b33d70a62c08774e6f5db2068cc03.jpeg",
    "https://cdn.faire.com/fastly/b27d245b0671cf49f6566ac528c98167494994e2875452293cbbdfc7eeaf6c7c.jpeg",
    "https://cdn.faire.com/fastly/40c30cc0443215b9371c7beef4f70dba72ca555cbfcbfabee95b9f423af19cfc.jpeg",
    "https://cdn.faire.com/fastly/bb5ada558c6772f93044f1079c05482394cf1c4d2b6730ff0f185b4ec2cb2367.jpeg",
    "https://cdn.faire.com/fastly/41d2198c2fae045a8bde6df2cf7ca6631a46462bcbc747a9fb7195ebada25ddb.jpeg",
  ],
  priceDollars: 17.45,
  description:
    "Features:\n * Trendy, Simple\n * Solid Color\n * Rivet Beaded Embellishments\n * Single Strap\n * Mini Dumpling Bag\n * Handbag & Evening Bag\n * Magnetic Snap Design\n * Versatile Style\n * Daily/ Party Fitting\n * Gift\n\n Weight: 90g\n\n Size: 23.5*2*20 cm\n\n Material:\n * Straw,Polyester\n\n Package:\n * Package include 1 * handbag.\n\n Note:\n * Keep away from direct sunlight, water, alcohol, and perfumes to prevent fading or damage.\n * Do not overfill the bag to maintain its shape and avoid unnecessary strain on the straps.\n * Clean gently with a soft cloth; do not use harsh chemicals or solvents.\n * Manual measurement may result in a 1–3 cm difference. Colors may vary slightly due to lighting and screen settings.",
  tags: [],
  msrpDollars: 34.89,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:32.118Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
